import classNames from "classnames";
import CuratedSearchPromptSection from "./CuratedSearchPrompt/CuratedSearchPromptSection";
import { useContext, useEffect } from "react";
import AutopilotCuratedSearchContext from "../../contexts/AutopilotCuratedSearchContext";
import useGenerateScoringCriteria from "../../reactHooks/curatedSearch/useGenerateScoringCriteria";
import CuratedSearchDesignTabsContainer from "./CuratedSearchDesignSteps/CuratedSearchDesignTabsContainer";
import AutopilotCuratedInternalSearchContext from "../../contexts/AutopilotCuratedInternalSearchContext";
import InternalAutopilotHydrationContext from "../../contexts/InternalAutopilotHydrationContext";

interface ICuratedSearchCriteriaAndFiltersContainer {
  selectedPrompt?: string;
  setSelectedPrompt: (prompt: string) => void;
  expandPrompt?: string;
  loading: boolean;
  startedGeneratingFilters: boolean;
  setStartedGeneratingFilters: (value: boolean) => void;
  isRemixStep?: boolean;
  suggestedPrompts?: string[];
}

const CuratedSearchCriteriaAndFiltersContainer = ({
  selectedPrompt,
  setSelectedPrompt,
  expandPrompt,
  loading,
  startedGeneratingFilters,
  setStartedGeneratingFilters,
  isRemixStep,
  suggestedPrompts,
}: ICuratedSearchCriteriaAndFiltersContainer) => {
  const {
    setScoringCriteriaValues,
    expandScoringCriteriaValues,
    specificCompanies,
    setSpecificCompanies,
  } = useContext(AutopilotCuratedSearchContext);

  const { savedFilters } = useContext(AutopilotCuratedInternalSearchContext);
  const { savedAnalysisPreview, savedPreviews, savedFilters: hydrationSavedFilters } = useContext(InternalAutopilotHydrationContext);

  const [generateScoringCriteria] = useGenerateScoringCriteria();

  useEffect(() => {
    if (expandScoringCriteriaValues.length > 0) {
      generateScoringCriteria({
        variables: {
          prompt: selectedPrompt || "",
          expandContext: {
            expandPrompt: expandPrompt || "",
            previousScoringCriteriaValues: expandScoringCriteriaValues,
          },
        },
        onCompleted: (data) => {
          setScoringCriteriaValues(data.generateScoringCriteria);
        },
      });
    }
  }, [
    expandScoringCriteriaValues,
    expandPrompt,
    selectedPrompt,
    generateScoringCriteria,
    setScoringCriteriaValues,
  ]);

  const handleSubmit = () => {
    setStartedGeneratingFilters(true);
    if (!isRemixStep) {
      generateScoringCriteria({
        variables: {
          prompt: selectedPrompt || "",
        },
        onCompleted: (data) => {
          setScoringCriteriaValues(data.generateScoringCriteria);
        },
      });
    }
  };

  return (
    <div
      className={classNames(
        "transition-all",
        "duration-500",
        "ease-in-out",
        "overflow-hidden",
        "w-full",
      )}
    >
      <div className={classNames("flex", "flex-col", "gap-4", "w-full")}>
        <CuratedSearchPromptSection
          specificCompanies={specificCompanies}
          setSpecificCompanies={setSpecificCompanies}
          handleSubmit={handleSubmit}
          isRemixStep={isRemixStep}
          loading={loading}
          selectedPrompt={selectedPrompt}
          setSelectedPrompt={setSelectedPrompt}
          setStartedGeneratingFilters={setStartedGeneratingFilters}
          startedGeneratingFilters={startedGeneratingFilters}
          suggestedPrompts={suggestedPrompts}
        />
        {startedGeneratingFilters && selectedPrompt && (
          <CuratedSearchDesignTabsContainer
            initialPrompt={selectedPrompt}
            initialFilters={savedFilters}
            specificCompanies={specificCompanies}
            savedFilters={hydrationSavedFilters}
            savedAnalysisPreview={savedAnalysisPreview}
            savedPreviews={savedPreviews}
          />
        )}
      </div>
    </div>
  );
};

export default CuratedSearchCriteriaAndFiltersContainer;
